<template>
  <main class="landing-page">
    <landing-header />

    <section id="about" class="hero-section">
      <div class="map-pin map-pin-teal map-pin-left" aria-hidden="true"></div>
      <div class="map-pin map-pin-blue map-pin-top" aria-hidden="true"></div>
      <div
        class="map-pin map-pin-purple map-pin-right"
        aria-hidden="true"
      ></div>
      <div
        class="map-pin map-pin-purple map-pin-bottom-left"
        aria-hidden="true"
      ></div>
      <div class="map-pin map-pin-blue map-pin-bottom" aria-hidden="true"></div>
      <div
        class="map-pin map-pin-teal map-pin-mid-right"
        aria-hidden="true"
      ></div>
      <div
        class="map-pin map-pin-purple map-pin-lower-right"
        aria-hidden="true"
      ></div>

      <div class="hero-content">
        <section class="hero-copy">
          <h1>
            Connecting Healthcare.<br />
            Powering Better Care.
          </h1>
          <p>
            CheckMarq is the trusted staffing platform that connects home health
            agencies, clinicians, and staffing agencies to build stronger teams
            and better outcomes.
          </p>
        </section>

        <div class="care-pin" aria-hidden="true">
          <div class="care-photo">
            <span class="care-person care-person-left"></span>
            <span class="care-person care-person-right"></span>
          </div>
        </div>
      </div>

      <landing-portal-cards class="hero-cards" />
    </section>

    <landing-footer />
  </main>
</template>

<script>
import LandingFooter from '@/components/public/LandingFooter'
import LandingHeader from '@/components/public/LandingHeader'
import LandingPortalCards from '@/components/public/LandingPortalCards'

export default {
  name: 'LandingPage',
  components: {
    LandingFooter,
    LandingHeader,
    LandingPortalCards,
  },
}
</script>

<style scoped lang="scss">
.landing-page {
  background: #ffffff;
  color: #06265c;
  min-height: 100vh;
}

.hero-section {
  background: linear-gradient(
      rgba(255, 255, 255, 0.72),
      rgba(255, 255, 255, 0.88)
    ),
    repeating-linear-gradient(
      26deg,
      transparent 0,
      transparent 78px,
      rgba(196, 204, 214, 0.44) 80px,
      transparent 84px
    ),
    repeating-linear-gradient(
      -34deg,
      transparent 0,
      transparent 92px,
      rgba(196, 204, 214, 0.36) 95px,
      transparent 99px
    ),
    radial-gradient(
      ellipse at 68% 58%,
      rgba(113, 194, 232, 0.36) 0 9%,
      transparent 10%
    ),
    radial-gradient(
      ellipse at 32% 24%,
      rgba(113, 194, 232, 0.22) 0 6%,
      transparent 7%
    ),
    #f5f7fb;
  min-height: 735px;
  overflow: hidden;
  padding: 76px 0 54px;
  position: relative;
}

.hero-section::before,
.hero-section::after {
  background: rgba(145, 192, 39, 0.09);
  content: '';
  height: 190px;
  position: absolute;
  transform: rotate(-18deg);
  width: 360px;
}

.hero-section::before {
  left: -90px;
  top: 85px;
}

.hero-section::after {
  bottom: 145px;
  right: 260px;
}

.hero-content {
  align-items: center;
  display: grid;
  gap: 44px;
  grid-template-columns: minmax(0, 1.25fr) minmax(300px, 0.75fr);
  margin: 0 auto;
  max-width: 1240px;
  padding: 0 34px;
  position: relative;
  z-index: 1;
}

.hero-copy {
  padding-left: 52px;
}

.hero-copy h1 {
  color: #052a61;
  font-size: 54px;
  font-weight: 800;
  letter-spacing: 0;
  line-height: 1.18;
  margin-bottom: 24px;
  max-width: 720px;
}

.hero-copy p {
  color: #071f55;
  font-size: 22px;
  font-weight: 500;
  line-height: 1.45;
  max-width: 650px;
}

.care-pin {
  background: linear-gradient(150deg, #1e8bf1 0%, #0068cf 70%, #0050aa 100%);
  border-radius: 52% 52% 52% 0;
  box-shadow: 0 20px 24px rgba(0, 78, 163, 0.26);
  height: 312px;
  justify-self: center;
  position: relative;
  transform: rotate(-45deg);
  width: 312px;
}

.care-pin::after {
  background: rgba(4, 59, 124, 0.12);
  border-radius: 50%;
  bottom: -38px;
  content: '';
  height: 24px;
  left: 56px;
  position: absolute;
  transform: rotate(45deg);
  width: 198px;
}

.care-photo {
  background: linear-gradient(
      135deg,
      rgba(255, 255, 255, 0.26),
      transparent 40%
    ),
    linear-gradient(135deg, #f7dbc1 0 35%, #dff0fb 36% 100%);
  border: 16px solid #ffffff;
  border-radius: 50%;
  height: 172px;
  left: 58px;
  overflow: hidden;
  position: absolute;
  top: 58px;
  transform: rotate(45deg);
  width: 172px;
}

.care-person,
.care-person::before,
.care-person::after {
  position: absolute;
}

.care-person {
  background: #ffffff;
  bottom: 0;
  display: block;
}

.care-person::before,
.care-person::after {
  content: '';
}

.care-person-left {
  border-radius: 34px 34px 0 0;
  height: 74px;
  left: 25px;
  width: 54px;
}

.care-person-left::before {
  background: #c57c48;
  border-radius: 50%;
  height: 38px;
  left: 8px;
  top: -30px;
  width: 38px;
}

.care-person-left::after {
  background: #a95f31;
  border-radius: 50% 50% 44% 44%;
  height: 46px;
  left: 2px;
  top: -34px;
  width: 32px;
}

.care-person-right {
  background: #1675bd;
  border-radius: 38px 38px 0 0;
  height: 88px;
  right: 18px;
  width: 68px;
}

.care-person-right::before {
  background: #e8b789;
  border-radius: 50%;
  height: 44px;
  left: 13px;
  top: -32px;
  width: 44px;
}

.care-person-right::after {
  border: 3px solid #052a61;
  border-left: 0;
  border-top: 0;
  border-radius: 0 0 24px 0;
  height: 30px;
  left: 19px;
  top: 30px;
  width: 30px;
}

.hero-cards {
  margin-top: 84px;
}

.map-pin {
  border-radius: 50% 50% 50% 0;
  box-shadow: 0 13px 14px rgba(6, 31, 72, 0.18);
  height: 42px;
  position: absolute;
  transform: rotate(-45deg);
  width: 42px;
  z-index: 1;
}

.map-pin::after {
  background: #ffffff;
  border-radius: 50%;
  content: '';
  height: 16px;
  left: 13px;
  position: absolute;
  top: 13px;
  width: 16px;
}

.map-pin-teal {
  background: #18a9ad;
}

.map-pin-blue {
  background: #2a76df;
}

.map-pin-purple {
  background: #6f45b7;
}

.map-pin-left {
  left: 13%;
  top: 10%;
}

.map-pin-top {
  left: 39%;
  top: 4%;
}

.map-pin-right {
  right: 9%;
  top: 10%;
}

.map-pin-bottom-left {
  bottom: 30%;
  left: 7%;
}

.map-pin-bottom {
  bottom: 36%;
  left: 52%;
}

.map-pin-mid-right {
  right: 5%;
  top: 43%;
}

.map-pin-lower-right {
  bottom: 34%;
  right: 15%;
}

@media only screen and (max-width: 1080px) {
  .hero-section {
    min-height: auto;
    padding-top: 48px;
  }

  .hero-content {
    gap: 40px;
    grid-template-columns: 1fr;
  }

  .hero-copy {
    padding-left: 0;
  }

  .care-pin {
    height: 250px;
    width: 250px;
  }

  .care-photo {
    height: 140px;
    left: 47px;
    top: 47px;
    width: 140px;
  }

  .hero-cards {
    margin-top: 60px;
  }
}

@media only screen and (max-width: $tablet-size) {
  .hero-copy h1 {
    font-size: 44px;
  }

  .hero-copy p {
    font-size: 19px;
  }
}

@media only screen and (max-width: $mobile-size) {
  .hero-section {
    padding: 38px 0 42px;
  }

  .hero-content {
    padding: 0 20px;
  }

  .hero-copy h1 {
    font-size: 35px;
  }

  .hero-copy p {
    font-size: 17px;
  }

  .care-pin {
    height: 210px;
    width: 210px;
  }

  .care-photo {
    border-width: 12px;
    height: 118px;
    left: 40px;
    top: 40px;
    width: 118px;
  }

  .map-pin {
    height: 32px;
    width: 32px;
  }

  .map-pin::after {
    height: 12px;
    left: 10px;
    top: 10px;
    width: 12px;
  }
}
</style>
